// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607231034/js/" + chunkId + "." + {"44":"0f8cb18d","225":"cac91c1f","481":"f68cee0b","486":"4849670d","770":"9b1d67f7"}[chunkId] + ".0.5795483636000229.chunk.js";
};